// extracted by mini-css-extract-plugin
export default {"promptModal":"promptModal__FS-of","footer":"footer__hyQ6T"};